// extracted by mini-css-extract-plugin
export default {"products":"Ks-z","card":"Ls-z","oosMessaging":"Ms-z"};